
    import("-!builtin:swc-loader??ruleSet[1].rules[0].use[0]!/home/jenkins/agent/workspace/frontend/frontend-build-and-deploy/reactUi/src/Application/XMattersApp/entryPoint.js");